import {STRATEGIES_REQUEST,STRATEGIES_SHOW, STRATEGIES_EDIT, STRATEGIES_CLEAR, STRATEGIES_FAIL} from "../store/config";

const strategiesInit = {
	isFetching: false,
	list: [],
	pages: {
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	filters: {
		q:''
	},
	edit: {},
	permissions: [],
	error: undefined
}

const strategies = (state = strategiesInit, action) => {
	switch (action.type) {
		case STRATEGIES_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case STRATEGIES_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case STRATEGIES_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case STRATEGIES_CLEAR:
			return {
				...state,
				edit: action.payload,
				timestamp: action.timestamp
			}
		case STRATEGIES_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return{
				...state
			}
	}
}

export default strategies;


// WEBPACK FOOTER //
// ./src/reducers/strategies.js